import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';

import PrivateRoute from './private';
import PublicRoute from './public';

import Terms from '../pages/Terms';
import MaskedCPF from '../pages/MaskedCpf';
import FillCpf from '../pages/FillCpf';
import VerifyToken from '../pages/VerifyToken';
import SelectContact from '../pages/SelectContact';
import ContractAgreementList from '../pages/ContractAgreementList';

import AbstractProposal from '../pages/AbstractProposal';
import Proposal from '../pages/Proposal';
import Options from '../pages/Options';
import TermsRoute from './terms';
import PortionAgreement from '../pages/PortionAgreement';
import Profile from '../pages/Profile';
import Address from '../pages/SelectAddress';
import Negotiation from '../pages/Negotiation';
import AbstractNegotiation from '../pages/AbstractNegotiation';
import PendingAndReject from '../pages/PendingAndReject';
import Widget from '../pages/Widget';
import Error from '../pages/Error';
import Confirmation from '../components/Confirmation';
import CookiesTerms from '../pages/CookiesTerms/CookiesTerms';
import GenerateBillet from '../pages/GenerateBillet';
import FillCpfBillet from '../pages/FillCpfBillet';
import { useSelector } from 'react-redux';
import TagManager from 'react-gtm-module';
import FAQ from '../pages/faq';
import Invoices from '../pages/Invoice';
import PaymentMethods from '../pages/PaymentMethods';
import AgreementSummary from '../pages/AgreementSummary';
import FinishedDeal from '../pages/FinishedDeal';

declare const window: Window & { dataLayer: Record<string, unknown>[] };

function Routes() {
  const { favicon, gTagManager, pageView, fontLink } = useSelector(
    (state: ApplicationState) => ({
      favicon: state.config.favicon,
      gTagManager: state.config.gTagManager,
      pageView: state.analytic.pageView,
      fontLink: state.config.linkFont,
    })
  );

  useEffect(() => {
    if (gTagManager) {
      TagManager.initialize({
        gtmId: `${gTagManager}`,
      });
    }
  }, [gTagManager]);

  useEffect(() => {
    if (gTagManager) {
      window.dataLayer.push({
        /* caso tenha que criar um evento personalizado */
        // event: 'pageView',
        analyticPageUrl: pageView,
      });
    }
  }, [pageView, gTagManager]);

  useEffect(() => {
    const updateOrCreateLink = (rel: string, href: string) => {
      const headElement = document.getElementsByTagName('head')[0];
      let linkElement = document.querySelector(
        `link[rel="${rel}"]`
      ) as HTMLLinkElement;

      if (!linkElement) {
        linkElement = document.createElement('link');
        linkElement.rel = rel;
        headElement.appendChild(linkElement);
      }

      linkElement.href = href;
    };

    const iconHref = favicon || '/favicon.ico';

    updateOrCreateLink('icon', iconHref);
    updateOrCreateLink('apple-touch-icon', iconHref);
  }, [favicon]);

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = fontLink;

    document.getElementsByTagName('head')[0].appendChild(link);

    return () => {
      document.getElementsByTagName('head')[0].removeChild(link);
    };
  }, [fontLink]);

  return (
    <Switch>
      <PublicRoute exact path='/' component={FillCpf} />
      <Route exact path='/gerar-boleto/:billetId' component={GenerateBillet} />
      <PublicRoute exact path='/boletagem' component={FillCpfBillet} />

      <PublicRoute exact path='/preencher-dados' component={FillCpf} />
      <Route path='/privacy-terms' component={CookiesTerms} />

      <PublicRoute exact path='/verifica-dados' component={FillCpf} />
      <PublicRoute exact path='/faq' component={FAQ} />

      <PublicRoute exact path='/:campaignId/:hashId' component={MaskedCPF} />

      <PublicRoute exact path='/contato' component={SelectContact} />
      <PublicRoute
        exact
        path='/contato/widget/:cpf'
        component={SelectContact}
      />
      <PublicRoute exact path='/validar-token' component={VerifyToken} />
      <Route exact path='/widget' component={Widget} />
      <TermsRoute exact path='/termos' component={Terms} />
      <PrivateRoute
        exact
        path='/acordos-debitos'
        component={ContractAgreementList}
      />
      <PrivateRoute exact path='/contrato' component={ContractAgreementList} />
      <PrivateRoute exact path='/proposta' component={Proposal} />
      <PrivateRoute
        exact
        path='/resumo-proposta'
        component={AbstractProposal}
      />
      <PrivateRoute
        exact
        path='/resumo-negociacao'
        component={AbstractNegotiation}
      />
      <PrivateRoute
        exact
        path='/confirmação-de-contatos'
        component={Confirmation}
      />
      <PrivateRoute exact path='/negociacao' component={Negotiation} />
      <PrivateRoute
        exact
        path='/negociacao-status'
        component={PendingAndReject}
      />
      <PrivateRoute exact path='/opcoes' component={Options} />
      <PrivateRoute exact path='/acordos' component={ContractAgreementList} />
      <PrivateRoute exact path='/parcela-acordo' component={PortionAgreement} />
      <PrivateRoute exact path='/perfil' component={Profile} />
      <PrivateRoute exact path='/enderecos' component={Address} />
      <PrivateRoute exact path='/faturas' component={Invoices} />
      <PrivateRoute
        exact
        path='/métodos-pagamento'
        component={PaymentMethods}
      />
      <PrivateRoute exact path='/resumo-acordo' component={AgreementSummary} />
      <PrivateRoute exact path='/acordo-finalizado' component={FinishedDeal} />
      <PrivateRoute exact path='/erro' component={Error} />
      <PublicRoute path='*' component={FillCpf} />
    </Switch>
  );
}

export default Routes;
